export default __webpack_public_path__ + "static/media/J'sLogo.ad87d4ff.png";